export const CONTENT_POPPER_ANIMATION_DURATION_MOUNT = 350;
export const CONTENT_POPPER_ANIMATION_DURATION_UNMOUNT = 100;
